import React from 'react';
import { safeHtmlLinks } from '@/utils/links/safeHref';

interface PostNoticeProps {
    title: string;
    content: string;
    // Added 'progress' to the type definition
    color: 'success' | 'warning' | 'error' | 'secondary' | 'green' | 'yellow' | 'gray' | 'progress';
}

// 1. Define base styles (Added progress here)
const styles = {
    success: `border-s-success border-success/15`,
    warning: `border-s-warning border-warning/15`,
    error: `border-s-error border-error/15`,
    secondary: `border-s-secondary border-secondary/15`,
    progress: `border-s-progress border-progress/15`, // New Progress Sty`
};

// 2. Map keys to styles
const colorClasses: Record<string, string> = {
    // Green Group
    success: styles.success,
    green: styles.success,

    // Yellow Group
    warning: styles.warning,
    yellow: styles.warning,

    // Error Group
    error: styles.error,

    // Gray Group
    secondary: styles.secondary,
    gray: styles.secondary,

    // Progress Group
    progress: styles.progress,
};

const PostNotice: React.FC<PostNoticeProps> = ({ title, content, color }) => {
    // 3. Fallback Logic:
    // If 'color' is invalid or undefined, use styles.progress as the "call back"
    const activeClass = colorClasses[color] ?? styles.progress;

    return (
        <blockquote
            className={`w-full items-center gap-3 border border-s-[5px] my-3 ${activeClass} rounded-xl bg-table dark:bg-white/10  p-4 text-right text-base xl:text-start`}
        >
            <span className='text-lg font-bold text-black dark:text-white'>{title}</span>
            <p
                className='text-justify leading-[1.9] [&>strong]:!font-bold text-sm mt-2 mb-0 !py-0 dark:!text-gray-300'
                dangerouslySetInnerHTML={{
                    __html: safeHtmlLinks(content || ''),
                }}
            />
        </blockquote>
    );
};

export default PostNotice;
